export default __webpack_public_path__ + "f02df937ec84225040421d32ca31f0bd.otf";